import { ControlPanel } from './ControlPanel.main';

export { ControlPanel };
